export var WebkitPresentationMode;!function(e){e.INLINE="inline",e.PIP="picture-in-picture"}(WebkitPresentationMode||(WebkitPresentationMode={}));